import { Router } from "@angular/router";
import { BehaviorSubject } from "rxjs";
import { Injectable } from "@angular/core";
import { HttpClient, HttpHeaders } from "@angular/common/http";
import { ConfigService } from "../services/config.service";
import { AuthorisationService } from '../../services/authorisation.service';

@Injectable()
export class AuthService {
  private loggedIn: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

  get isLoggedIn() {
    return this.loggedIn.asObservable();
  }

  constructor(
    private router: Router,
    private http: HttpClient,
    private cs: ConfigService,
    private authSvc: AuthorisationService
  ) {
    this.checkAuthStatus();
  }

  //We can either assign on login or we could constantly check the database
  checkAuthStatus() {
    if (localStorage.getItem('chronolog-user')) {
      this.loggedIn.next(true);
    }
    else {
      this.loggedIn.next(false);
    }
  }

  checkAuthRole(roleCode) {
    let vm: any;
    vm = JSON.parse(localStorage.getItem('chronolog-user'));
    
    let isAuthenticated: boolean = false;
    
    //Roles
    if (vm != null && vm.RoleCodes != null) {
      vm.RoleCodes.forEach((element) => {
        if (roleCode == element) {
          isAuthenticated = true;
        }
      });    
    }
    
    return isAuthenticated;
  }

  getUser() {
    let vm: any;
    vm = JSON.parse(localStorage.getItem('chronolog-user'));
    return vm;
  }

  getLoginResult() {
    let vm: any;
    vm = JSON.parse(localStorage.getItem('login-result'));
    return vm;
  }

  login(vm: any) {
    this.loggedIn.next(true);
    localStorage.setItem('chronolog-user', JSON.stringify(vm));

    //console.log(vm);

    //this.router.navigate(['/pages']);
    //this.router.navigate([vm.DefaultHomeUrl]);
    //window.location.href = vm.DefaultHomeUrl;
  }

  logout() {
    this.loggedIn.next(false);

    // Clear auth-specific localStorage keys (not everything — other tabs may still be active)
    localStorage.removeItem('chronolog-token');
    localStorage.removeItem('chronolog-user');
    localStorage.removeItem('login-result');

    // Clear effective-auth cache so next login fetches fresh permissions
    this.authSvc.clear();
    
    // Navigate to login page
    this.router.navigate(['/account/login']);
    
    // Call logout endpoint to revoke refresh token in database
    const loginUrl = this.cs.loginEndPoint;
    if (!loginUrl) {
      return; // Config not loaded yet, skip server-side logout
    }
    const companyName = this.getCompanyName();
    
    const options = {
      headers: new HttpHeaders({
        'Content-Type': 'application/json',
        'company-name': companyName
      }),
      withCredentials: true
    };

    this.http.post(`${loginUrl}/api/auth/logout`, {}, options).subscribe();
  }

  private getCompanyName(): string {
    const url = window.location.href;
    const urlParts = url.split('/');
    const printMatch = url.match(/print/g);
    const cMatch = url.includes('/c/');
    const positionToExtract = (printMatch && printMatch.length > 1) || cMatch ? 4 : 3;
    
    if (urlParts.length > positionToExtract) {
      return urlParts[positionToExtract] || '';
    }
    return '';
  }
}
